import { DatePipe } from '@angular/common';
import { LdgImgComponent } from '@/app/atoms/ldg-img/ldg-img.component';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CreateMonitoring } from '../../services/create-monitoring';
import { ImageService } from '@/app/services/image/image.service';

@Component({
  selector: 'cmb-monitoring-review',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, LdgImgComponent],
  templateUrl: './monitoring-review.html',
  styleUrl: './monitoring-review.scss',
})
export class MonitoringReview {
  public readonly createMonitoringService = inject(CreateMonitoring);
  public readonly imageService = inject(ImageService);

  readonly monitorTypeName = computed(() => {
    const match = this.createMonitoringService.monitoringTypeOptions.find(
      (option) => option.type === this.createMonitoringService.monitorType(),
    );
    return match?.name ?? 'Monitoring';
  });

  /** Selected window, or the same 30-day default the brief is submitted with. */
  readonly windowStart = computed(() => this.createMonitoringService.monitorStart() ?? this.daysFromToday(-30));

  readonly windowUntil = computed(() => this.createMonitoringService.monitorUntil() ?? this.daysFromToday(30));

  readonly usingDefaultWindow = computed(
    () => !this.createMonitoringService.monitorStart() && !this.createMonitoringService.monitorUntil(),
  );

  readonly creatorSummary = computed(() => {
    switch (this.createMonitoringService.creatorSourceMethod()) {
      case 'one': {
        const count = this.createMonitoringService.manualCreators().length;
        return count ? `${count} added by hand` : 'No creators added yet';
      }
      case 'csv':
        return this.createMonitoringService.uploadedCsvUrl() ? 'CSV file attached' : 'No CSV uploaded yet';
      case 'shout':
        return this.createMonitoringService.selectedList()?.groupName ?? 'No group selected';
      default:
        return 'Add creators later';
    }
  });

  private daysFromToday(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() + days);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
